<template>
  <div class="wrapper">
    <!-- header部分 -->
    <header>
      <p>商家列表</p>
    </header>
    <!-- 商家列表部分 -->
    <ul class="business">
      <!-- v-for 列表渲染展示businessArr -->
      <li v-for="item in businessArr" :key="item.businessId" @click="toBusinessInfo(item.businessId)  ">
        <div class="business-img">
          <!-- base64展示图片 -->
          <img :src="item.businessImg" />
          <div class="business-img-quantity" v-show="item.quantity > 0">
            {{ item.quantity }}
          </div>
        </div>
        <div class="business-info">
          <h3>{{ item.businessName }}</h3>
          <p>
            &#165;{{ item.starPrice }}起送 | &#165;{{ item.deliveryPrice }}配送
          </p>
          <p>{{ item.businessExplain }}</p>
        </div>
      </li>
    </ul>
    <!-- 底部菜单部分 -->
    <Footer></Footer>
  </div>
</template>
   <script>
import Footer from "../components/Footer.vue";

export default {
  name: "BusinessList",
  data() {
    return {
      //路由目的通过this.$route.query取出传入的参数
      orderTypeId: this.$route.query.orderTypeId,
      businessArr: [],
      user: {},
    };
  },
  //组件生命周期的一开始就执行下面的事情
  created() {
    this.user = this.$getSessionStorage("user");

    //根据orderTypeId查询商家信息,post方法请求，第一个参数是url，第二个就是参数
    this.$axios
      .post(
        "BusinessController/listBusinessByOrderTypeId",
        this.$qs.stringify({
          //箭头函数的this是上一级代码块的this
          orderTypeId: this.orderTypeId,
        })
      )
      .then((response) => {
        //返回的json用businessArr接收
        this.businessArr = response.data;
        //判断是否登录，已经登陆就展示上面小红点
        if (this.user != null) {
          this.listCart();
        }
      })
      .catch((error) => {
        console.error(error);
      });
  },
  components: {
    Footer,
  },
  methods: {
    listCart() {
      this.$axios
        .post(
          "CartController/listCart",
          this.$qs.stringify({
            userId: this.user.userId,
          })
        )
        .then((response) => {
          let cartArr = response.data;
          //下面可以优化，使用map，直接便利cart，根据其中的businessId来++map[businessId],最后遍历一遍map
          //即可，得到每个商家的quantity，复杂度由O(N*M)->O(N)+O(M)

          //遍历每一个商家,businessArr已经被前面的created中赋值了
          for (let businessItem of this.businessArr) {
            businessItem.quantity = 0;
            //对于每一个商家遍历cart，计算这个商家点的数量
            for (let cartItem of cartArr) {
              if (cartItem.businessId == businessItem.businessId) {
                businessItem.quantity += cartItem.quantity;
              }
            }
          }
          //最后排序显示,？？存疑,根据什么来排序的？
          this.businessArr.sort();
        })
        .catch((error) => {
          console.error(error);
        });
    },
    //点击商家跳转到商家信息businessInfo页面
    toBusinessInfo(businessId) {
      this.$router.push({
        path: "/businessInfo",
        query: { businessId: businessId },
      });
    },
  },
};
</script>
   <style scoped>
/****************** 总容器 ******************/
.wrapper {
  width: 100%;
  height: 100%;
}
/****************** header部分 ******************/
.wrapper header {
  width: 100%;
  height: 12vw;
  background-color: #0097ff;
  color: #fff;
  font-size: 4.8vw;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}
/****************** 商家列表部分 ******************/
.wrapper .business {
  width: 100%;
  margin-top: 12vw;
  margin-bottom: 14vw;
}
.wrapper .business li {
  width: 100%;
  box-sizing: border-box;
  padding: 2.5vw;
  border-bottom: solid 1px #ddd;
  user-select: none;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.wrapper .business li .business-img {
  /*这里设置为相当定位，成为business-img-quantity元素的父元素*/
  position: relative;
}
.wrapper .business li .business-img img {
  width: 20vw;
  height: 20vw;
}
.wrapper .business li .business-img .business-img-quantity {
  width: 5vw;
  height: 5vw;
  background-color: red;
  color: #fff;
  font-size: 3.6vw;
  border-radius: 2.5vw;
  display: flex;
  justify-content: center;
  align-items: center;
  /*设置成绝对定位，不占文档流空间*/
  position: absolute;
  right: -1.5vw;
  top: -1.5vw;
}
.wrapper .business li .business-info {
  margin-left: 3vw;
}
.wrapper .business li .business-info h3 {
  font-size: 3.8vw;
  color: #555;
}
.wrapper .business li .business-info p {
  font-size: 3vw;
  color: #888;
  margin-top: 2vw;
}
</style>
